import {Picker, PickerItemProps} from '@react-native-picker/picker';
import T from './T';
import React from 'react';

import {
  useController,
  UseControllerProps,
  useFormContext,
} from 'react-hook-form';
import {StyleSheet, Text, View} from 'react-native';

interface BTPickerItemProps extends PickerItemProps, UseControllerProps {
  label: string;
  defaultValue?: string;
  onValChange?: any;
}

function BTComboBox(props: any) {
  const {onValChange} = props;
  const formContext = useFormContext();

  const {
    name,
    label,
    rules,
    defaultValue,
    onValChange: _,
    ...inputProps
  } = props;

  const {field, fieldState} = useController({name, rules, defaultValue});

  if (!formContext || !name) {
    const msg = !formContext
      ? 'Combobox must be wrapped by the FormProvider'
      : 'Name must be defined';
    console.error(msg);
    return null;
  }

  return (
    <View style={styles.container}>
      {label && <Text style={styles.label}><T>{label}</T></Text>}
      <View
        style={[styles.pickerWrapper, !!fieldState.error && styles.inputError]}>
        <Picker
          onValueChange={(newValue, itemIndex) => {
            field.onChange(newValue);

            if (onValChange) {
              onValChange(newValue);
            }
          }}
          onBlur={field.onBlur}
          selectedValue={field.value}
          {...inputProps}
          enabled={inputProps.editable}
          style={styles.picker}
          dropdownIconColor="black">
          <Picker.Item key={0} label={'--Select--'} value={0} />
          {props.data?.map((dat: {label: string; id: string}, i: number) => {
            return <Picker.Item key={i} label={dat.label} value={dat.id} />;
          })}
        </Picker>
      </View>
      {!!fieldState.error && (
        <Text style={styles.error}><T>{fieldState.error.message}</T></Text>
      )}
    </View>
  );
}

export default BTComboBox;

const styles = StyleSheet.create({
  label: {
    marginLeft: 0,
    marginBottom: 2,
  },
  error: {
    marginLeft: 0,
    color: 'red',
  },
  container: {
    flex: -1,
    justifyContent: 'center',
    padding: 0,
  },
  input: {
    backgroundColor: 'white',
    color: 'black',
    height: 35,
    borderRadius: 4,
    padding: 0,
  },
  inputError: {
    borderColor: 'red',
    backgroundColor: '#f9d7d3',
  },
  pickerWrapper: {
    height: 57,
    backgroundColor: 'white',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#ccc',
    justifyContent: 'center',
    paddingVertical: 0,
    overflow: 'hidden',
  },
  picker: {
    height: '100%',
    color: 'black',
    fontSize: 10,
  },
});

